// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const FIREBASE_STATE_CHANGED = 'FIREBASE_STATE_CHANGED';
export const FIREBASE_USER_UPDATE = 'FIREBASE_USER_UPDATE';
export const FIREBASE_INSERT_PRODUCT_DETAILS = 'FIREBASE_INSERT_PRODUCT_DETAILS';
export const FIREBASE_FETCH_PRODUCT_DETAILS = 'FIREBASE_FETCH_PRODUCT_DETAILS';
export const FIREBASE_INSERT_PRODUCT_IMAGES = 'FIREBASE_INSERT_PRODUCT_IMAGES';
export const FIREBASE_FETCH_PRODUCT_IMAGES = 'FIREBASE_FETCH_PRODUCT_IMAGES';

// action - chatgpt reducer
export const FETCH_ANSWER = 'FETCH_ANSWER';
export const FETCH_BILLING = 'FETCH_BILLING';
export const FETCH_PROJECT = 'FETCH_PROJECT';
export const FETCH_VECTOR = 'FETCH_VECTOR';
